module.exports = "../dist/img/product-card-26.6d3a.jpg";